"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLogo = exports.Title = exports.LogoWrapper = exports.StyledGrid = exports.ContainerStyled = void 0;
const styles_1 = require("@mui/material/styles");
const Container_1 = __importDefault(require("@mui/material/Container"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const Logo_1 = __importDefault(require("@/components/Logo"));
exports.ContainerStyled = (0, styles_1.styled)(Container_1.default)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
});
exports.StyledGrid = (0, styles_1.styled)(Grid_1.default)({
    display: "flex",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
});
exports.LogoWrapper = (0, styles_1.styled)("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    flexWrap: "nowrap",
    flexDirection: "column",
    marginBottom: theme.spacing(3),
}));
exports.Title = (0, styles_1.styled)(Typography_1.default)(({ theme }) => ({
    color: theme.palette.institutional.braskemGray,
}));
exports.StyledLogo = (0, styles_1.styled)(Logo_1.default)({
    height: "70px",
});
